<div class="page-section">
  <div class="header-section">
    <img src="assets/images/branding/intelycare-logo-primary-tm-logo-full-color-rgb.svg" />
  </div>
  <div class="content-section">
    <h3>
      Are you looking to <b>request IntelyPros </b> to work at your facility? Install the app
    </h3>
    <div class="buttons-section">
      <a *ngIf="platform.IOS; else platformAndroid"
         mat-button
         href="{{ STORE_URL.APP_STORE_URL }}">
        <img src="assets/images/appStore_button.svg">
      </a>

      <ng-template #platformAndroid>
        <a mat-button
           href="{{ STORE_URL.PLAY_STORE_URL }}">
          <img src="assets/images/googleplay_button.svg">
        </a>
      </ng-template>
    </div>
    <p>Looking to do something else?</p>
    <a [routerLink]="getProperLandingPage()" class="navigation-link">Continue</a>
  </div>
</div>
